import React from 'react';

function Link({ href, children }) {
  return (
    <a
      href={href}
      className="relative text-gray-700 hover:text-[#0dceda] transition-colors duration-200 py-2"
    >
      {children}
      <span className="absolute bottom-0 left-0 w-full h-0.5 bg-[#0dceda] transform scale-x-0 transition-transform duration-200 origin-left hover:scale-x-100" />
    </a>
  );
}

export default Link;